import React from "react";

const AppContext = React.createContext({ a: 1, b: 2 });

export default AppContext;
